import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment setting for requesting retailer to assign a star-rating to each of the brand review metrics.
 */
export const BRAND_REVIEW_FORM_VALUE_RATINGS_XP_250120 =
  'BRAND_REVIEW_FORM_VALUE_RATINGS_XP_250120' as SettingConst<
    'BRAND_REVIEW_FORM_VALUE_RATINGS_XP_250120',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
